export default () => {
    document.querySelectorAll('.js-toggler').forEach(t => {
        t.addEventListener('click', (e) => {
            e.preventDefault()
            const classToUse = t.dataset["class"]
            const target = t.dataset["target"]
            if (target.indexOf("#") === 0) {
                document.querySelector(target).classList.toggle(classToUse)
            } else {
                t.closest(target).classList.toggle(classToUse)
            }
            return false
        })
    })
}